
import {toPng} from 'html-to-image'
import Kpi from './kpi.vue'
import Tracker from './tracker/tracker.vue'
import OrgMap from './org-map'

export default {
  components: {Kpi, OrgMap, Tracker},
  props: {
    widget: {type: Object, required: true},
    snapshot: {type: Boolean, default: false}
  },
  computed: {
    widget_type(){
      if (['kpi'].includes(this.widget.type)) return 'card'
      return this.widget.type
    },
    markdown() {
      return ['orgmap', 'tracker_companies', 'tracker_contacts', 'tracker_topics'].includes(this.widget.type) && this.widget.markdown
    }
  },

  methods: {
    async getImage(fontEmbedCSS) {
      if (this.markdown) return {markdown: this.markdown}
      await this.$refs.kpi?.fitText()
      const base64 = await toPng(this.$refs.element, 
        {fontEmbedCSS, preferredFontFormat: 'woff2', cacheBust: false}
      )
      return {base64}
    }
  }
}
